import { render, staticRenderFns } from "./TitleRow.vue?vue&type=template&id=0cfef0e4&scoped=true"
import script from "./TitleRow.vue?vue&type=script&lang=js"
export * from "./TitleRow.vue?vue&type=script&lang=js"
import style0 from "./TitleRow.vue?vue&type=style&index=0&id=0cfef0e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfef0e4",
  null
  
)

export default component.exports